<template lang="pug">
v-container.grid-list-xl
  v-layout(row wrap)
    v-flex(lg12 sm12 xs12)
      v-card.app-card
        v-card-title.app-card-title(v-text="'N° da viagem: '+form.id")
        v-row(justify="space-between" class="pa-5")
          v-col(:md="4" :sm="4" :xs="12" cols="12")
            v-btn(
                color="success"
                @click="activeBackTravel = !activeBackTravel"
                :disabled="form.sentido === this.SentidoViagem.VOLTA ? true:checkPermissonTravel "
                block
              )
                  v-icon(v-text="'place'")
                  span(v-text="'Viagem Volta'")

          v-col(:lg="4" :md="6" :sm="4" :xs="12" cols="12" )
            v-dialog(
              v-model="dialog"
              persistent
              max-width="290"
            )
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="active"
                  block
                )
                  v-icon(v-text="'block'")
                  span(v-text="'Encerrar Viagem'")

              v-card
                v-card-title(class="d-flex flex-column justify-center title-card")
                  //- v-icon(v-text="'question_mark'" class="questionIcon")
                  p(class="text-h5 mt-5" v-text="'Finalizar Viagem?'")
                    
                v-card-actions(class="d-flex justify-space-between")
                  v-btn(
                    color="primary darken-1"
                    text
                    :disabled="disabledBtn"
                    :loading="disabledBtn"
                    @click="finishTravel"
                    variant="flat"
                  )
                     span(v-text="'Sim'")
                     .alert.alert-danger(v-if='error' v-text="error")
                  v-btn(
                    color="primary darken-1"
                    text
                    @click="dialog = false"
                    v-text="'Não'"
                  )

        v-card-text.app-card-content
          v-row
            v-col(:md="4" :sm="4" :xs="12" cols="12")
              strong(v-text="'Origem: '")
              span(v-text="form.municipioOrigemNome")

            v-col(:md="4" :sm="4" :xs="12" cols="12")
              strong(v-text="'Destino: '")
              span(v-text="form.municipioDestinoNome")

            v-col(:md="4" :sm="4" :xs="12" cols="12")
              strong(v-text="'Status: '")
              span(v-text="form.status")
            
            v-col(:md="4" :sm="4" :xs="12" cols="12")
              strong(v-text="'Viagem iniciada: '")
              span(v-text="formatDate(form.dataInicio)")
            
            v-col(:md="4" :sm="4" :xs="12" cols="12")
              strong(v-text="'Viagem finalizada: '")
              span(v-text="formatDate(form.dataFim)")
            
            v-col(:md="4" :sm="4" :xs="12" cols="12")
              strong(v-text="'Sentido: '")
              span(v-text="form.sentido")

            v-col(:md="12" :sm="12" :xs="12" cols="12")
              h3(v-text="'Passageiros'")
              v-col(cols="12")
                v-autocomplete(
                  :items="form.passageiroList" 
                  :loading="false" 
                  v-model="form.values"
                  prepend-inner-icon="search"
                  item-text="nome"
                  outlined
                  clearable
                  multiple
                  small-chips
                  return-object
                  :disabled='activeBackTravel'
                )
                template(v-slot:no-data)
                    v-list-item
                      v-list-item-title(v-text="'Passageiros'")
              
                template(v-slot:selection="{ attr, on, item }")
                    v-list-item
                      v-list-item-title(v-text="item")
              
                template(v-slot:item="{ item }")

            v-col(:md="12" :sm="12" :xs="12" cols="12")
              v-row(justify="end" class="pr-3")
                v-btn(
                  color="info"
                  :disabled='activeBackTravel'
                  :loading="loadingBtn"
                  @click="backTravel"
                  class="mb-3"
                )
                  span(v-text="'Salvar'")
                .alert.alert-danger(v-if='error' v-text="error")
              section.loading(v-if='loading')
              v-progress-linear(:active='loading' :indeterminate='loading' absolute bottom color='#2e70b6')
          

</template>

<script src="http://www.openlayers.org/api/OpenLayers.js"></script>
<script>
import ViagensService from "@/services/viagens.service";
import GlobalStore from "@/store/modules/global";
import { throwError } from "rxjs";
import { getLocation } from "@/util/geolocation";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { cadastroViagemDB, viagensOfflineDB } from "@/helpers/dexieDb";
import { mapState, mapActions } from "vuex";
import { SentidoViagem } from "@/models/sentido-viagem.enum";
import { StatusViagem } from "@/models/status-viagem.enum";

export default {
  data: () => ({
    dialog: false,
    form: {
      id: "",
      municipioOrigemNome: "",
      municipioDestinoNome: "",
      municipioOrigemId: "",
      municipioDestinoId: "",
      dataInicio: "",
      dataFim: "",
      status: "",
      sentido: "",
      latitude: "",
      longitude: "",
    },
    numero: "",
    passageiroList: [],
    values: [],
    loading: true,
    active: false,
    checkTravelBack: false,
    error: "",
    alertError: "",
    activeBackTravel: true,
    loadingBtn: false,
    checkValidity: false,
    checkPermissonTravel: false,
    checkDirection: false,
    inforRoutes: [],
    detailsTravel: [],
    disabledBtn: false,
    SentidoViagem: SentidoViagem,
  }),
  methods: {
    search(id) {
      ViagensService.details(id).subscribe((result) => {
        this.detailsTravel = result;
        result.forEach((value) => {
          const {
            id,
            municipioOrigem,
            municipioDestino,
            status,
            passageiroList,
            dataInicio,
            dataFim,
            sentido,
          } = value;
          this.form.id = id;
          this.form.municipioOrigemNome = municipioOrigem.nome;
          this.form.municipioOrigemId = municipioOrigem.id;
          this.form.municipioDestinoNome = municipioDestino.nome;
          this.form.municipioDestinoId = municipioDestino.id;
          this.form.status = status;
          this.form.passageiroList = this.filterPassengers(passageiroList);
          this.form.values = this.filterPassengers(passageiroList);
          this.form.dataInicio = dataInicio;
          this.form.dataFim = dataFim;
          this.form.sentido = sentido;
        });
        this.disabledButtom(this.form.status);
      }),
        (error) => {
          throwError(error);
        };
    },
    finishTravel() {
      if (this.latitude != undefined && this.longitude != undefined) {
        this.form.dataFim = this.dateToday();
        this.form.latitude = this.latitude;
        this.form.longitude = this.longitude;
        this.form.status = StatusViagem.FINALIZADA;
        this.disabledBtn = true;
        this.saveTravelFinish(this.form);
      }
      this.showPosition();
    },
    disabledButtom(status) {
      if (status === StatusViagem.FINALIZADA) return (this.active = true);
    },
    showPosition() {
      getLocation().subscribe(
        (res) => {
          this.latitude = res.latitude;
          this.longitude = res.longitude;
        },
        (error) => {
          this.alertError = ", ative sua localização";
          GlobalStore.setSnackBar({
            show: true,
            message: "Ative sua localização",
            type: "error",
          });
        }
      );
    },
    backTravel() {
      this.loadingBtn = true;
      const body = {
        viagemOrigemId: this.form.id,
        latitude: this.latitude,
        longitude: this.longitude,
        municipioOrigemId: this.form.municipioDestinoId,
        municipioDestinoId: this.form.municipioOrigemId,
        municipioDestinoNome: this.form.municipioOrigemNome,
        municipioOrigemNome: this.form.municipioDestinoNome,
        passageiroList: this.form.values,
        dataInicio: this.dateToday(),
      };

      this.saveTravelBack(body);
    },
    redirectNotSincronized() {
      this.$router.push({
        name: "my-trips-pending",
      });
    },
    async visualizarCache() {
      let viagem = await cadastroViagemDB.cadastroViagem.toArray();
    },
    filterPassengers(passengers) {
      const filterPassengers = passengers.filter((value) => value.nome != "");
      return filterPassengers;
    },
    filterRoutes(routes) {
      const filterRoutes = routes.filter((value) => value.sentido === "IDA");
      return filterRoutes;
    },
    permissionBackTravel(id) {
      ViagensService.permissionBackTravel(id).subscribe(
        (result) => {
          result.hasPermissionToCreateViagemVolta
            ? (this.checkPermissonTravel = false)
            : (this.checkPermissonTravel = true);
        },
        (error) => {
          throwError(error);
        }
      );
    },
    dateToday() {
      var dataHoraAtual = new Date();
      dataHoraAtual.setUTCHours(dataHoraAtual.getUTCHours());
      return dayjs(dataHoraAtual.toISOString()).format("YYYY-MM-DDTHH:mm:ss");
    },
    backToTravelList() {
      this.$router.push({
        name: "my-trips",
      });
    },
    searchCache(id) {
      viagensOfflineDB.viagens.get(id).then((res) => {
        this.detailsTravel = res;
        const {
          id,
          municipioOrigem,
          municipioDestino,
          status,
          passageiroList,
          dataInicio,
          dataFim,
          sentido,
        } = res;
        this.form.id = id;
        this.form.municipioOrigemNome = municipioOrigem.nome;
        this.form.municipioOrigemId = municipioOrigem.id;
        this.form.municipioDestinoNome = municipioDestino.nome;
        this.form.municipioDestinoId = municipioDestino.id;
        this.form.status = status;
        this.form.passageiroList = this.filterPassengers(passageiroList);
        this.form.values = this.filterPassengers(passageiroList);
        this.form.dataInicio = dataInicio;
        this.form.dataFim = dataFim;
        this.form.sentido = sentido;
        this.disabledButtom(this.form.status);
      });
    },
    formatDate(date) {
      if (date != null) {
        if (!this.table.tableOffline.offline) {
          return dayjs(date).format("DD/MM/YYYY HH:mm");
        } else {
          return date;
        }
      }
      return " --/--/---- ";
    },
    ...mapActions("viagens", { saveTravelIndexDB: "SAVE_TRAVEL_INDEXDB" }),
    ...mapActions("viagens", { saveTravelFinish: "SAVE_TRAVEL_FINISH" }),
    ...mapActions("viagens", { verifyIndexDB: "VERIFY_INDEXDB" }),
    ...mapActions("viagens", { saveTravelBack: "SAVE_TRAVEL_BACK" }),
  },
  computed: {
    ...mapState("viagens", ["pageRedirect"]),
    ...mapState("viagens", ["table"]),
  },
  watch: {
    pageRedirect: function () {
      this.backToTravelList();
    },
  },
  mounted() {
    this.visualizarCache();
    this.showPosition();
    this.loading = false;
    const { id } = this.$route.params;
    this.searchCache(id);
    this.search(id);
    this.permissionBackTravel(id);
  },
};
</script>

<style>
.questionIcon {
  background-color: #005eb6;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid black;
  margin-bottom: 1rem;
  color: white;
}
</style>
